import graphql__ae36f12fff658bfa0e93 from "./__generated__/InformativeMarker_marker.graphql.js";/* global L */

import { useCallback } from "react";
import ReactDOMServer from "react-dom/server";
import { graphql, useFragment } from "react-relay";
import { Marker } from "react-leaflet";

import MapTooltip from "./MapTooltip";
import Icon from "../Utils/Icon";
import { useNavigateTo } from "../Routes/RoutesContext";

const InformativeMarker = ({ size = 35, tooltipProps = {}, ...props }) => {
  const marker = useFragment(InformativeMarker_marker, props.marker);
  const { latitude, longitude } = marker;
  const { backgroundColor } = marker.markerStyle;

  const html = ReactDOMServer.renderToString(
    <Icon
      className="icon-map-marker text-shadow-lg"
      style={{ color: backgroundColor, fontSize: size }}
    />
  );

  const iconLeftOffset = size * (12.5 / 35);
  const icon = L.divIcon({
    html,
    className: "map-marker map-marker-informative",
    iconSize: [size, size],
    iconAnchor: [iconLeftOffset, size],
    tooltipAnchor: [-iconLeftOffset + size / 2, -(size / 2)]
  });

  const tooltipContent = marker.tooltipContent?.replace(/\n/g, "<br>");

  const children =
    props.children ||
    (tooltipContent?.length > 0 && (
      <MapTooltip {...tooltipProps}>
        <div
          className="text-title-overview-sm"
          dangerouslySetInnerHTML={{ __html: tooltipContent }}
        />
      </MapTooltip>
    ));

  const navigateTo = useNavigateTo();
  const handleClick = useCallback(
    () => marker.targetUrl && navigateTo(marker.targetUrl),
    [marker.targetUrl, navigateTo]
  );

  if (!latitude || !longitude) return null;

  const position = [latitude, longitude];

  return (
    <Marker
      icon={icon}
      eventListeners={{ click: handleClick }}
      position={position}
      {...props}
    >
      {children}
    </Marker>
  );
};

const InformativeMarker_marker = graphql__ae36f12fff658bfa0e93;

export default InformativeMarker;
